import { getBrandEmail } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerEmail } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getUserEmail, getUserFullName, getUserPhoneNumber } from "@faire/help-center-utils/serialized-data/getUser";
import { useScrollToTopOnLoadEffect } from "./useScrollToTopEffect";
import { useSelectedBrandOrderNumber } from "./useSelectedBrandOrderNumber";
import { useSelectedOrderToken } from "./useSelectedOrderToken";
export var useInitializeCallRequestField = function useInitializeCallRequestField() {
  var _ref, _getRetailerEmail;
  var userFullName = getUserFullName();
  var emailAddress = (_ref = (_getRetailerEmail = getRetailerEmail()) !== null && _getRetailerEmail !== void 0 ? _getRetailerEmail : getBrandEmail()) !== null && _ref !== void 0 ? _ref : getUserEmail();
  var phoneNumber = getUserPhoneNumber();
  var selectedBrandOrderNumber = useSelectedBrandOrderNumber();
  var selectedOrderToken = useSelectedOrderToken();
  useScrollToTopOnLoadEffect(10);
  var callRequestInitial = {
    name: userFullName,
    email: emailAddress,
    phone: phoneNumber,
    brandOrderNumber: selectedBrandOrderNumber,
    details: "",
    orderToken: selectedOrderToken
  };
  return {
    callRequestInitial: callRequestInitial
  };
};